<ul>
    <li v-for="item in column.data.list">
        {{ item }}
    </li>
</ul>